const ENUM_VALUES = [
  'CONVERTIBLE',
  'COUPE',
  'CROSSOVER',
  'HATCHBACK',
  'LIMOUSINE',
  'MINIVAN',
  'PICKUP_CREW_CAB',
  'PICKUP_CREW_CAB_CHASSIS',
  'PICKUP_DOUBLE_CAB',
  'PICKUP_EXTENDED_CAB',
  'PICKUP_EXTENDED_CAB_CHASSIS',
  'PICKUP_MEGA_CAB',
  'PICKUP_REGULAR_CAB',
  'PICKUP_REGULAR_CAB_CHASSIS',
  'ROADSTER',
  'SEDAN',
  'SPECIALTY',
  'SUV',
  'VAN',
  'WAGON'
]

const HUMAN_READABLE = [
  'Convertible',
  'Coupe',
  'Crossover',
  'Hatchback',
  'Limousine',
  'Minivan',
  'Crew Cab Pickup',
  'Crew Cab Pickup w/Chassis',
  'Double Cab Pickup',
  'Extended Cab Pickup',
  'Extended Cab Pickup w/Chassis',
  'Mega Cab Pickup',
  'Regular Cab Pickup',
  'Regular Cab Pickup w/Chassis',
  'Roadster',
  'Sedan',
  'Specialty Vehicle',
  'SUV',
  'Van',
  'Wagon'
]

/**
 * Converts GraphQL body type enumeration values to display values.
 * @param {String} value
 * @return {String}
 */
export const fromEnum = value => HUMAN_READABLE[ENUM_VALUES.indexOf(value)]

/**
 * Converts GraphQL body type display values to enumeration values.
 * @param {String} value
 * @return {String}
 */
export const toEnum = value => ENUM_VALUES[HUMAN_READABLE.indexOf(value)]
